import { isDevModeAtom } from "#/store/app/devMode/devMode";

import { getJotaiStore } from "./getJotaiStore";

let hasCheckedLocalStorage = false;
const store = getJotaiStore();

export const getIsDevMode = (): boolean => {
  const atomValue = store.get(isDevModeAtom);

  // If the atom has loaded the true value from storage or we've already synced it
  if (atomValue || hasCheckedLocalStorage) {
    return atomValue;
  }

  try {
    const storedValue = localStorage.getItem("DEVMODE");

    if (storedValue !== null) {
      const parsedValue = JSON.parse(storedValue);
      store.set(isDevModeAtom, parsedValue);
      hasCheckedLocalStorage = true;
      return parsedValue;
    }
  } catch {
    // If localStorage fails, keep the default
  }

  hasCheckedLocalStorage = true;

  return atomValue;
};
